var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule",staticStyle:{"width":"100%"}},[_c('van-nav-bar',{attrs:{"title":"拉新规则","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$goBack()}}}),_c('img',{attrs:{"src":_vm.jobInfo.jobExInfo.ruleUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }